<template>
  <div class="account-info">
    <div class="my-info">
      <div v-if="isLogin" class="info flex-center">
        <van-image :src="imageView(myInfo.avatar)" fit="cover"
          style="overflow: hidden; width: 40px; height: 40px;border-radius: 50%;" />  
        <div style="flex: 1;margin-left: 12px;">
          <div class="name">{{ myInfo.nickName }}</div>
          <div class="id">ID:{{ myInfo.userId.split('_')[1] }}</div>
        </div>      
      </div>
      <div v-else class="login-info">
        <div class="login-text">暂未登录</div>
        <div class="login-btn" @click="goLogin">立即登录</div>
      </div>
    </div>
    <div class="swipe">
      <van-swipe :autoplay="3000" :show-indicators="false">
        <van-swipe-item v-for="(image, index) in slides" :key="index">
          <van-image @click="goUrl(image)" :src="imageView(image.poster)" fit="fill"
            style=" overflow: hidden; width: 100%; height: 184px;" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="tabs flex-center" v-if="showHomePageServiceEntry">
      <div class="item flex-center" @click="goNextPage('match-entry')">
        <div class="flex-center">
          <img src="https://images.snsports.cn/FiQSoskgEqlx2kjq1tCi2Ma0wCyS" />
        </div>
        赛事报名
      </div>
      <div class="item flex-center" @click="goPage()">
        <div class="flex-center" :style="{ 'background': account.themeColor }">
          <img src="	https://images.snsports.cn/Ft3eb5ty_CjgM9B48s2JMxfMvA_4" />
        </div>
        年度注册
      </div>
      <div class="item" style="background-color: #F3F3F3;" @click="handleSecretClick"></div>
    </div>
    <div class="match">
      <div class="title flex-center">
        推荐赛事
        <span @click="goNextPage('match-entry')">赛事列表<van-icon name="arrow" /></span>
      </div>
      <div class="list">
        <div class="item flex-center" v-for="item in  list " :key="item.id" @click="goMatch(item.id)">
          <van-image :src="imageView(item.backgroundImage2)" fit="cover"
            style="overflow: hidden; width: 90px; height: 68px;border-radius: 4px;" />
          <div class="info">
            <div class="name overflow-text">{{ item.chineseName }}</div>
            <div class="date flex-center">
              <img src="https://images.snsports.cn/Fm2RayG_dtlnxkII31oAX4hdurkA" />
              {{ getFormatDate(item.beginDate) }}-{{ getFormatDate(item.endDate) }}
            </div>
            <div class="status" :style="{ 'background': item.state === '可报名' ? '#FCD127' : '' }">{{ item.state }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="news">
      <div class="title flex-center">
        最新资讯
        <span @click="goNextPage('news')">更多资讯<van-icon name="arrow" /></span>
      </div>
      <div class="list">
        <div v-for="item in newList" :key="item.id" class="item flex-center" @click="goDetail(item)">
          <div class="overflow-text">{{ item.title }}</div>
          <span>{{ getDate(item.publishDate) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem, Image as VanImage, Tag, List, Toast } from 'vant'
Vue.use(Swipe).use(SwipeItem).use(VanImage).use(Tag).use(List).use(Toast)
import {
  getCrmAccountHome,
  getCrmAccountUnionMatchList,
  getCrmNewsList
} from '@/api/match'
import { QNImageUtil, RegExpr, DateUtil } from '@/utils'
import { getToken, removeToken } from '@/libs/cookie-storage'
import { AppType } from '@/constants/appType'
import wx from 'weixin-js-sdk'
import { getProfile } from '@/api/user'

export default {
  data() {
    return {
      account: {},
      slides: [],
      list: [],
      newList: [],
      showHomePageServiceEntry: 0,
      clickTimes: 0,
      lastClickTime: 0,
      isLogin: false,
      myInfo: {}
    };
  },
  mounted() {
    this.accountId = this.$route.params.accountId
    this.getCrmAccountHome()
    this.getCrmAccountUnionMatchList()
    this.getCrmNewsList()
    if (getToken()) {
      this.getMyInfo()
    }
  },
  methods: {
    getMyInfo() {
      getProfile().then(res => {
        this.myInfo = res.data.user
        this.isLogin = true
      })
    },
    goLogin() {
      // 判断是否在微信小程序环境
      if (AppType.isInWeChat() && window.__wxjs_environment === 'miniprogram') {
        console.log(1111)
        const url = '/pages/common/login'
        wx.miniProgram.navigateTo({ url })
      } else {
        // 普通环境
        let redirect = window.location.hash
        redirect = redirect.substring(1)
        this.$router.push({name:'AuthLogin', query: { redirect: encodeURIComponent(redirect) }})
      }
    },
    handleSecretClick() {
      console.log(111);
      const now = new Date().getTime();

      // 如果两次点击间隔超过1秒，重置计数
      if (now - this.lastClickTime > 1000) {
        this.clickTimes = 0;
      }

      this.clickTimes++;
      this.lastClickTime = now;

      // 连续点击三次触发
      if (this.clickTimes >= 3) {
        removeToken();
        this.clickTimes = 0;
        console.log(111);
        Toast('触发隐藏退出登陆')
      }
    },
    getCrmAccountHome() {
      const params = {
        accountId: this.accountId
      }
      getCrmAccountHome(params).then(res => {
        const { data } = res
        this.showHomePageServiceEntry = data.account.showHomePageServiceEntry
        this.account = data.account || {}
        this.slides = data.slides || []
        document.title = this.account.name
        const shareObj = {
          title: this.account.name,
          abstract: this.account.remark,
          image: QNImageUtil.imageView(this.account.logo)
        }
        this.wxShare(shareObj)
        // this.updateTime()
      })
    },
    imageView(img, w = '', h) {
      if (!img) return ''
      if (w === 'default') w = window.innerWidth - 24
      return QNImageUtil.imageView(img, w, h)
    },
    handleNavigate(path) {
      console.log(path);
      
      if (AppType.isInWeChat() && window.__wxjs_environment === 'miniprogram') {
        // 微信小程序环境
        console.log('小程序环境');
        
        const baseUrl = process.env.NODE_ENV === 'development' 
          ? 'https://www.snsports.cn/match-h5-dev/index.html#'
          : 'https://www.snsports.cn/match-h5/index.html#'
        const fullPath = `${baseUrl}${path}`
        wx.miniProgram.navigateTo({
          url: `/pages/webview/index?redirect=${encodeURIComponent(fullPath)}`
        })
      } else {
        console.log('普通环境');
        
        // 普通环境
        this.$router.push(path)
      }
    },
    handleExternalLink(url) {
      if (AppType.isInWeChat() && window.__wxjs_environment === 'miniprogram') {
        // 微信小程序环境
        wx.miniProgram.navigateTo({
          url: `/pages/webview/index?redirect=${encodeURIComponent(url)}`
        })
      } else {
        // 普通环境
        window.location.href = /^[http://|https://]/.test(url) ? url : `https://${url}`
      }
    },
    goUrl(item) {
      if (RegExpr.checkNum(item.url)) {
        const path = item.regEndDate && new Date().getTime() < new Date().getTime(item.regEndDate)
          ? `/entry-page?unionMatchId=${item.url}`
          : `/union-match?unionMatchId=${item.url}`
        this.handleNavigate(path)
      } else if (/\S+/.test(item.url)) {
        this.handleExternalLink(item.url)
      }
    },
    goNextPage(type) {
      const routes = {
        'news': `/account/news-list/${this.accountId}`,
        'match-entry': `/account/entry-list/${this.accountId}`,
        'my-entry-list': `/account/my-entry-list/${this.accountId}`,
        'about-us': `/account/about-us/${this.accountId}`
      }
      
      if (routes[type]) {
        this.handleNavigate(routes[type])
      }
    },
    getCrmAccountUnionMatchList() {
      const params = {
        accountId: this.accountId,
        state: 0,
        pageSize: 2,
        pageNum: 1
      }
      getCrmAccountUnionMatchList(params).then(res => {
        if (res) {
          const { data } = res
          this.list = data.list
          console.log(data);
        }
      })
    },
    getCrmNewsList() {
      const params = {
        accountId: this.accountId,
        pageSize: 5,
        pageNum: 1
      }
      getCrmNewsList(params).then(res => {
        if (res) {
          const { data } = res
          this.newList = data.list
        }
      })
    },
    goDetail(item) {
      if (item.contentType === 2) {
        this.handleExternalLink(item.sourceUrl)
      } else {
        this.handleNavigate(`/account/news-detail/${item.id}`)
      }
    },
    getDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{m}/{d}')
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}.{m}.{d}')
    },
    goMatch(id) {
      this.handleNavigate(`/union-match/match-overall?unionMatchId=${id}`)
    },
    goPage() {
      const passport = getToken() || ''
      const baseUrl = process.env.NODE_ENV === 'development' 
        ? 'https://www.snsports.cn/assoc-v2-stage/index.html'
        : 'https://www.snsports.cn/assoc-v2/index.html'
      
      const url = `${baseUrl}#/pages/adminRegister/index?associationId=${this.account.associationId}&passport=${passport}`
      
      this.handleExternalLink(url)
    }
  },
};
</script>

<style scoped lang="scss">
.account-info {
  background-color: #F3F3F3;
  min-height: 100vh;
  padding-bottom: 66px;
  box-sizing: border-box;
  .my-info{
    height: 60px;
    padding: 0 16px;
    .info{
      height: 100%;
      color: #4D4D4D;
      .name{
        font-size: 15px;
      }
      .id{
        font-size: 11px;
      }
    }
    .login-info{
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .login-text{
        font-size: 15px;
        color: #9E9E9E;
      }
      .login-btn{
        width: 80px;
        height: 32px;
        border-radius: 3px;
        border: 1px solid #2A63F6;
        font-size: 15px;
        color: #2A63F6;
        text-align: center;
        line-height: 30px;
        box-sizing: border-box;
      }
    }
  }

  .swipe {
    width: 100%;
    height: 184px;
  }

  .tabs {
    margin-top: 12px;
    padding: 0 10px;
    justify-content: flex-start;

    .item {
      border-radius: 4px;
      width: 83px;
      height: 92px;
      background-color: #fff;
      font-size: 12px;
      color: #4D4D4D;
      flex-direction: column;
      margin-right: 7px;

      img {
        width: 27px;
        height: 27px;
      }

      div {
        width: 46px;
        height: 46px;
        background: #0FAC7F;
        border-radius: 50%;
        margin-bottom: 4px;
      }
    }
  }

  .match {
    padding: 0 10px;
    margin-top: 22px;



    .list {
      .item {
        margin-top: 10px;
        height: 92px;
        border-radius: 4px;
        background: #FFFFFF;

        .info {
          flex: 1;
          margin-left: 10px;
          // height: 100%;

          .name {
            font-size: 14px;
            font-weight: 500;
            color: #4B4B4B;
          }

          .date {
            font-size: 10px;
            color: #8D8D8D;
            margin-top: 4px;
            justify-content: flex-start;

            img {
              width: 12px;
              height: 12px;
              margin-right: 6px;
            }
          }

          .status {
            width: 43px;
            height: 18px;
            border-radius: 2px;
            text-align: center;
            line-height: 18px;
            font-size: 10px;
            font-weight: 500;
            color: #FFFFFF;
            margin-top: 12px;
            background: #0FAC7F;
          }
        }
      }
    }
  }

  .news {
    padding: 0 10px;
    margin-top: 24px;

    .list {
      background-color: #fff;
      border-radius: 4px;
      padding: 10px 0;
      margin-top: 10px;

      .item {
        font-size: 13px;
        color: #4D4D4D;
        justify-content: space-between;
        padding: 0 16px;
        height: 40px;
        line-height: 40px;

        div {
          width: 250px;
        }

        span {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.26);
        }
      }
    }
  }

  .title {
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;

    span {
      font-size: 12px;
      color: #8D8D8D;
    }
  }
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
